import loadTourStripe from './loadTourStripe';

export const RadarSessionFailures = {
  noPublishableKey: 'noPublishableKey',
  stripeUnavailable: 'stripeUnavailable',
  sessionRefused: 'sessionRefused',
};

// The session is tied to the payment attempt, so it is minted at submit rather than kept in the
// store. The backend refuses a tour booking without one, so a failure resolves with its cause and
// the booking saga stops before anything is sent.
const createTourRadarSession = async (publishableKey) => {
  if (!publishableKey) {
    return { failure: RadarSessionFailures.noPublishableKey };
  }

  const stripe = await loadTourStripe(publishableKey);
  if (!stripe) {
    return { failure: RadarSessionFailures.stripeUnavailable };
  }

  try {
    const result = await stripe.createRadarSession();
    const sessionId = result && result.radarSession && result.radarSession.id;
    return sessionId ? { sessionId } : { failure: RadarSessionFailures.sessionRefused };
  } catch (error) {
    return { failure: RadarSessionFailures.sessionRefused, message: error && error.message };
  }
};

export default createTourRadarSession;
